import { useMutation } from "@tanstack/react-query"
import { updatePurchaseOrderAttachment } from "customerAttachments/apis"
import { PurchaseAttachType } from "customerAttachments/types"

type useUploadPurchaseAttachmentsProps = {
  orderNo: string
  attachType: PurchaseAttachType
}

const useUploadPurchaseAttachments = ({ orderNo, attachType }: useUploadPurchaseAttachmentsProps) => {
  const { mutateAsync, isLoading } = useMutation({
    mutationKey: ["uploadPurchaseAttachments"],
    mutationFn: (payload: { Files: { FileName: string; Base64: string }[] }) =>
      updatePurchaseOrderAttachment({ orderNo, attachType, payload }),
  })
  return { mutate: mutateAsync, isLoading }
}

export default useUploadPurchaseAttachments
